import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";

import Index from "./pages/Index";
import Browse from "./pages/Browse";
import Publish from "./pages/Publish";
import SkillDetail from "./pages/SkillDetail";
import Profile from "./pages/Profile";
import NipPage from "./pages/NipPage";
import ConnectAgent from "./pages/ConnectAgent";
import MySkills from "./pages/MySkills";
import EditSkill from "./pages/EditSkill";
import { NIP19Page } from "./pages/NIP19Page";
import NotFound from "./pages/NotFound";

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/browse" element={<Browse />} />
        <Route path="/publish" element={<Publish />} />
        <Route path="/skill/:pubkey/:identifier" element={<SkillDetail />} />
        <Route path="/profile/:npub" element={<Profile />} />
        <Route path="/nip" element={<NipPage />} />
        <Route path="/connect-agent" element={<ConnectAgent />} />
        <Route path="/my-skills" element={<MySkills />} />
        <Route path="/edit/:identifier" element={<EditSkill />} />
        {/* NIP-19 route for npub1, note1, naddr1, nevent1, nprofile1 */}
        <Route path="/:nip19" element={<NIP19Page />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
export default AppRouter;